export default "__VITE_ASSET__DMfA0_y3__"